import React, { useState, useEffect, useRef } from "react";

import { 
  Campaign, 
  CampaignNPC,
  VendorInvItem,
} from "@dndModels";

import DandDAPI from "@dndUtilities/system_api";
import { makeStyles } from "@utilities/theme_utilities";

import EditableLabel from "@components/input/strings/EditableLabel";
import FlexBox from "@components/layout/FlexBox";
import StringBox from "@components/input/strings/StringBox";

interface Props {
  campaign: Campaign;
  npc: CampaignNPC;
  inv_item: VendorInvItem;
}

const api = DandDAPI.getInstance();

export default function VendorInventoryItemInput({ npc, inv_item }: Props) {
  const [reloading, setReloading] = useState(false);
  // const [processing, setProcessing] = useState(false);
  const [ping, setPing] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '4px',
        marginBottom: '4px',
      },
    });
  });

  const { classes, cx } = useStyles();

  return (
    <FlexBox direction="column">
      <FlexBox direction="row">
        <EditableLabel
          name="Name"
          value={inv_item.name}
          fontSize={24}
          onChange={ async (changed: string) => {
            inv_item.name = changed;
            api.upsertObject("campaign_npc", npc);
            setPing(!ping);
          }}
        />
      </FlexBox>
      {/* <FlexBox>
        <StringBox
          name="Details"
          value={inv_item.description}
          multiline
          onChange={(changed: string) => {
            inv_item.description = changed;
            api.upsertObject("campaign_npc", npc);
            setPing(!ping);
          }}
        />
      </FlexBox> */}
      <FlexBox>
        <StringBox
          name="Price"
          value={inv_item.price}
          onChange={(changed: string) => {
            inv_item.price = changed;
            api.upsertObject("campaign_npc", npc);
            setPing(!ping);
          }}
        />
      </FlexBox>
    </FlexBox>
  );
}
